var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { isValidTicketField } from "../Utils";
import { postReq } from "../request";
import { TICKET_CREATE_URL, VISITOR_ID } from "../globals";
import { AppContext } from "../appContext";
import CloseWidgetPanel from "./CloseWidgetPanel";
var TicketForm = function (props) {
    var parentContext = useContext(AppContext);
    var openTicket = props.openTicket, backToList = props.backToList, setTickets = props.setTickets, tickets = props.tickets;
    var fields = [
        {
            name: "to",
            label: "Enter Email",
            type: "email",
            required: true,
            value: "",
            placeholder: "Email",
            error: "",
            is_valid: true,
            helpText: "Messages and ticket updates will be sent to this email address",
        },
        {
            name: "subject",
            label: "Subject",
            type: "text",
            required: true,
            value: "",
            placeholder: "Subject",
            error: "",
            is_valid: true,
        },
        {
            name: "description",
            label: "Description",
            type: "textarea",
            required: true,
            value: "",
            placeholder: "Description",
            error: "",
            is_valid: true,
        },
        // {
        //   name: "date",
        //   label: "When did the issue occur",
        //   type: "date",
        //   required: true,
        //   value: "",
        //   placeholder: "",
        //   error: "",
        //   is_valid: true,
        // },
    ];
    var _a = useState(fields), formFields = _a[0], setFormFields = _a[1];
    var _b = useState(false), saving = _b[0], setSaving = _b[1];
    var handleFieldValueChange = function (value, field) {
        var results = formFields.map(function (eachField) {
            if (eachField.name == field.name)
                eachField.value = value;
            if (eachField.error)
                eachField = isValidTicketField(eachField);
            return eachField;
        });
        setFormFields(results);
    };
    var submitForm = function () {
        if (isvalidForm() && !saving) {
            setSaving(true);
            var body = {};
            formFields.forEach(function (field) {
                if (field.name == "to")
                    body.requester_email = field.value;
                else if (field.name == "subject")
                    body.subject = field.value;
                else
                    body.text_body = field.value;
            });
            body.visitor_id = VISITOR_ID;
            var wait = postReq(TICKET_CREATE_URL, body);
            wait
                .then(function (response) {
                var newTicket = response.data;
                // console.log(response);
                setTickets(__spreadArray([newTicket], tickets, true));
                openTicket(newTicket.id);
            })
                .catch(function (e) {
                // console.log(e);
            });
        }
    };
    var isvalidForm = function () {
        var isValid = true;
        var results = formFields.map(function (field) {
            field = isValidTicketField(field);
            if (isValid)
                isValid = field.is_valid;
            return field;
        });
        setFormFields(results);
        return isValid;
    };
    return (_jsxs("div", __assign({ className: "chat__conversation chat__help chat__create-ticket" }, { children: [_jsxs("div", __assign({ className: "chat__header" }, { children: [_jsx("div", __assign({ "data-trigger": "all", className: "chat__header-back chat__help-action", onClick: function () { return backToList(); } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", color: "currentColor" }, { children: _jsx("path", { stroke: "#fff", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.7", d: "m14 18-6-6 6-6" }) })) })), _jsx("div", __assign({ className: "chat__header-user" }, { children: _jsx("h3", __assign({ className: "chat__header-user-name" }, { children: "Create Ticket" })) })), _jsx("div", __assign({ className: "chat__help-end" }, { children: _jsx(CloseWidgetPanel, {}) }))] })), _jsx("div", __assign({ className: "chat__content" }, { children: _jsx("div", __assign({ className: "chat__messages" }, { children: _jsx("div", __assign({ className: "chat__messages-track" }, { children: _jsx("div", __assign({ className: "chat__ticket-form-main" }, { children: _jsxs("div", __assign({ className: "chat__ticket-form" }, { children: [formFields.map(function (field, index) {
                                        return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "chat__ticket-form-group" }, { children: (function () {
                                                    switch (true) {
                                                        case field.type == "textarea": {
                                                            return (_jsxs(_Fragment, { children: [_jsxs("label", __assign({ className: "chat__ticket-form-label" }, { children: [field.label, " ", _jsx("span", __assign({ className: "theme-color" }, { children: "*" }))] })), _jsx("textarea", { placeholder: field.placeholder, required: field.required, value: field.value, name: field.name, className: "chat__ticket-form-control", rows: 5, onChange: function (e) {
                                                                            return handleFieldValueChange(e.target.value, field);
                                                                        } }), field.error ? (_jsx("div", __assign({ className: "error-content" }, { children: field.error }))) : (_jsx(_Fragment, {}))] }));
                                                        }
                                                        default: {
                                                            return (_jsxs(_Fragment, { children: [_jsxs("label", __assign({ className: "chat__ticket-form-label" }, { children: [field.label, " ", _jsx("span", __assign({ className: "theme-color" }, { children: "*" }))] })), _jsx("input", { type: field.type, placeholder: field.placeholder, required: field.required, name: field.name, className: "chat__ticket-form-control", value: field.value, onChange: function (e) {
                                                                            return handleFieldValueChange(e.target.value, field);
                                                                        } }), field.error ? (_jsx("div", __assign({ className: "error-content" }, { children: field.error }))) : (_jsx(_Fragment, {}))] }));
                                                        }
                                                    }
                                                })() })) }));
                                    }), _jsx("span", __assign({ style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        } }, { children: _jsx("button", __assign({ className: "chat__messages-btn", onClick: submitForm, style: {
                                                display: "flex",
                                                alignItems: "center",
                                                width: "auto",
                                                cursor: "pointer",
                                                marginTop: "20px",
                                            } }, { children: saving ? "Saving ..." : "Create Ticket" })) }))] })) })) })) })) }))] })));
};
export default TicketForm;
